// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableListButton_button__9yatU {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 2px;
  padding: 2px;
  border: 1px solid lightgray;
  min-width: 2rem;
  height: 2rem;
}
.TableListButton_button__9yatU:hover {
  border-color: black;
}
.TableListButton_button__9yatU:disabled {
  border-color: lightgray;
  color: lightgray;
}

.TableListButton_large__3fmZ2 {
  width: 2.5rem;
  height: 2.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/Buttons/TableListButton.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEA;EACI,uBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,cAAA;AADF","sourcesContent":[".button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  border-radius: 2px;\n  padding: 2px;\n  border: 1px solid lightgray;\n  min-width: 2rem;\n  height: 2rem;\n}\n.button:hover {\n  border-color: black;\n}\n.button:disabled {\n  border-color: lightgray;\n  color: lightgray;\n}\n\n.large {\n  width: 2.5rem;\n  height: 2.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `TableListButton_button__9yatU`,
	"large": `TableListButton_large__3fmZ2`
};
export default ___CSS_LOADER_EXPORT___;
